import { useTimeAgo } from '@vueuse/core'
import { toValue } from 'vue'

/**
 * Returns the relative time since/until a specific date
 * @returns {string}
 */
export const timeAgo = (isoDate) => toValue(useTimeAgo(isoDate))

/**
 * Returns the relative number of days since/until two specific dates
 * @returns {number}
 */
export const daysAgo = (toIsoDate, fromIsoDate) => {
  const from = fromIsoDate ? new Date(toValue(fromIsoDate)) : new Date()
  const then = new Date(toValue(toIsoDate))
  const MILLIS_IN_A_DAY = 1000 * 60 * 60 * 24

  return Math.floor((from - then) / MILLIS_IN_A_DAY)
}

/**
 * Returns the relative number of days since/until a specific date with date descriptors
 * @returns {string}
 */
export const daysInterval = (isoDate) => {
  const daysAgoValue = daysAgo(isoDate)
  return daysAgoValue === 0
    ? 'today'
    : daysAgoValue < 0
      ? daysAgoValue === -1 ? 'tomorrow' : `in ${Math.abs(daysAgoValue)} days`
      : daysAgoValue === 1 ? 'yesterday' : `${daysAgoValue} days ago`
}
